<template>
    <v-card>
        <v-card-text class="pb-1">
            <v-row>
                <v-col
                    class="px-0"
                    cols="3">
                    <date-range-field
                        class="mx-4"
                        v-model="pagination.dateRange"
                        @input="changedateRange"/>
                </v-col>
                <v-col
                    class="px-0"
                    cols="4">
                    <v-text-field
                        outlined
                        hide-details
                        height="40px"
                        append-icon="search"
                        v-model="pagination.search"
                        :placeholder="$t('placeholder.filterBySaleNameEmailAndPhone')"/>
                </v-col>
                <v-col cols="2">
                    <v-select
                        outlined
                        hide-details
                        v-model="pagination.approveStatus"
                        append-icon="expand_more"
                        height="40px"
                        v-on:change="changeapproveStatus"
                        item-value="value"
                        item-text="text"
                        :menu-props="{
                            offsetY: true
                        }"
                        :items="approveList"/>
                </v-col>
                <v-col cols="3">
                </v-col>
            </v-row>
        </v-card-text>
        <v-card-text>
            <sale-agent-table
                :search="pagination.search"
                :items="saleAgentRequests"
                :options="pagination"
                :excludeHeaders="[
                    $constant.table.SALE_AGENT_KEY.isActive,
                    $constant.table.SALE_AGENT_KEY.subRoles,
                    $constant.table.SALE_AGENT_KEY.totalAmount,
                    $constant.table.SALE_AGENT_KEY.totalTickets,
                    $constant.table.SALE_AGENT_KEY.id,
                    $constant.table.SALE_AGENT_KEY.totalCommission
                ]"
                @viewDetails="openRequestDetails"/>
        </v-card-text>

        <right-panel
            ref="updateSaleRequestPanel"
            :title="$t('saleAgent.requestDetails')">
            <template v-slot:content="{ context }">
                <sale-agent-details-view
                    ref="saleAgentDetailsView"
                    :disablerole="false"
                    :saleAgent="context"
                    @closeRightPanel="closeRightPanel"/>
            </template>

            <template v-slot:bottom="{ context }">
                <icon
                    value="delete"
                    size="20px"
                    :style="{
                        borderRadius: '4px',
                        border: '1px solid #a7a4a4',
                        padding: '8px 20px',
                        marginRight: '8px'
                    }"
                    @click="onClickSaleAgentPanelDelete"/>

                <div
                    :style="{ width: '145px'}">
                    <v-select
                        v-if="context"
                        outlined
                        hide-details
                        v-model="context.isVerified"
                        append-icon="expand_more"
                        height="40px"
                        item-value="value"
                        item-text="text"
                        :menu-props="{
                            offsetY: true
                        }"
                        :items="statusList">
                        <template v-slot:item="{ item }">
                            <div
                                :class="{
                                    'green--text': item === 'approve',
                                    'red--text': item === 'reject'
                                }">
                                {{ $t(`status.${item}`) }}
                            </div>
                        </template>

                        <template v-slot:selection="{ item }">
                            <div
                                :class="{
                                    'green--text': item === 'approve',
                                    'red--text': item === 'reject'
                                }">
                                {{ $t(`status.${item}`) }}
                            </div>
                        </template>
                    </v-select>
                </div>
                <v-spacer/>
                <v-btn
                    width="120px"
                    color="primary"
                    @click="onClickSaleAgentPanelSave">
                    {{ $t('button.save') }}
                </v-btn>
            </template>
        </right-panel>
    </v-card>
</template>

<script>
import DateRangeField from '@/components/fields/DateRangeField'
import SaleAgentTable from '@/components/tables/SaleAgentTable'
import RightPanel from '@/components/panels/RightPanel'
import SaleAgentDetailsView from '@/views/SaleAgentDetailsView'
import { mapState } from 'vuex'

export default {
    name: 'SaleAgentRequestListView',

    components: {
        DateRangeField,
        SaleAgentTable,
        RightPanel,
        SaleAgentDetailsView
    },

    props: {
        saleAgentRequests: {
            type: Array,
            default: () => []
        },

        pagination: {
            type: Object,
            default: () => ({})
        }
    },

    computed: {
        ...mapState('saleagentRequestList', ['requestlist'])
    },

    data () {
        return {
            approveList: [
                {
                    value: 'all',
                    text: 'ทุกสถานะ'
                },
                {
                    value: this.$constant.APPROVE_STATUS,
                    text: this.$t('status.approve')
                },
                {
                    value: this.$constant.REJECT_STATUS,
                    text: this.$t('status.reject')
                },
                {
                    value: this.$constant.WAITING_STATUS,
                    text: this.$t('status.waiting')
                }
            ],

            statusList: [
                'waiting',
                'approve',
                'reject'
            ]
        }
    },

    methods: {
        openRequestDetails (saleAgent) {
            const cloneSaleAgent = JSON.parse(JSON.stringify(saleAgent))
            this.$store.commit('saleagentRequestList/setRequestdetail', saleAgent)
            this.$refs.updateSaleRequestPanel.open(cloneSaleAgent)
        },
        changeapproveStatus (value) {
            var optionData = {}
            if (value === 'all') {
                optionData = {
                }
            } else {
                optionData = {
                    isVerified: value
                }
            }
            this.$store.commit('saleagentRequestList/setOption', optionData)
            this.$store.dispatch('saleagentRequestList/fetchRequestlist')
        },
        closeRightPanel () {
            this.$refs.updateSaleRequestPanel.close()
        },
        changedateRange (value) {
            const datestart = new Date(value[0])
            const dateend = new Date(value[1])
            const diffTime = Math.abs(dateend - datestart)
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
            if (diffDays > 30) {
                alert('กรุณาเลือกไม่เกิน 30 วัน')
                return
            }
            this.$store.commit('saleagentRequestList/setStartdate', new Date(value[0]).toISOString())
            this.$store.commit('saleagentRequestList/setEnddate', new Date(value[1]).toISOString())
            this.$store.dispatch('saleagentRequestList/fetchRequestlist')
        },

        onClickSaleAgentPanelDelete () {
            this.$refs.saleAgentDetailsView.deleteUser()
        },

        onClickSaleAgentPanelSave () {
            this.$refs.saleAgentDetailsView.patchRequest()
        }
    }
}
</script>

<style lang="scss" scoped></style>
